import {StyleSheet} from 'react-native';

import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {
    backgroundColor: white,
    height: '100%',
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH as number,
    alignSelf: 'center' as const,
  },
});
